module.exports = __webpack_public_path__ + "img/checkbox_sprite.b03d473d.svg";